import { Images } from '../assets'
import {React} from 'react'
import { Link } from 'react-router-dom'
import Tag from './Tag'

const ProjectCard = ({ image, logo, desc, link, title, bgColor, landscape = false, invert = false, tag = true, client, sectorTags, geographyTags, outcome, ctaLabel = 'View Case Study', published = true, noCta = false, compactImage = false, imageHeight }) => {

  const cardContent = (
    <div data-aos="fade-up" className={`${landscape ? 'project-card flex-col md:flex-row items-center ' : 'project-card flex-col items-center'} h-full`}>
      <div className={bgColor === 'purple' ? 'image bgPurple' : 'image bgBlue'} style={imageHeight ? { height: imageHeight } : compactImage ? { height: '196px' } : undefined}>
        <img decoding="async" src={image} alt="" loading="lazy" />
      </div>
      <div className={`${invert ? 'gap-4 w-full order-first' : 'gap-4 w-full'} flex-1`}>
        {tag && !sectorTags && !geographyTags && <div className='flex gap-x-2 mb-3'>
          <Tag title={"Mobile App"} />
          <Tag title={"Web"} />
        </div>}
        <div className="flex flex-row flex-wrap gap-1 mb-3">
          {sectorTags?.map(t => <span key={t} className="tag text-xs">{t}</span>)}
          {geographyTags?.map(t => <span key={t} className="tag text-xs">{t}</span>)}
        </div>
        {title && <div className="heading-six">{title}</div>}
        {client && <p className="text-sm text-[#5B5B5B] mt-1 mb-2">{client}</p>}
        {(outcome || desc) && <p className='text-gray'>{outcome || desc}</p>}
        {!noCta && (published ? (
          <div className="mt-4 w-max">
            <span className='btn btn-link text-primary500' style={{padding : 0}}>{ctaLabel}<img decoding="async" src={Images.ArrowRight} alt="" loading="lazy" /> </span>
          </div>
        ) : (
          <span className="inline-block mt-4 text-sm text-[#7E7E7E] font-medium">Coming Soon</span>
        ))}
      </div>
    </div>
  )

  return published && link && !noCta ? (
    <Link to={link}>{cardContent}</Link>
  ) : (
    <>{cardContent}</>
  )
}

export default ProjectCard
